import React, { Component } from "react";
import constants from "../../constants";
export const TimeoutContext = React.createContext();

const timeoutConst = constants.userTimeout;

export class TimeoutProvider extends Component {
	state = {
		timeout: timeoutConst,
	};

	componentDidMount() {
		const localStorageTimeout = window.localStorage.getItem("session_timeout");
		this.setState({
			timeout: localStorageTimeout ? localStorageTimeout : timeoutConst,
		});
	}

	handleTimeoutUpdate = (value) => {
		this.setState({ timeout: value });
	};

	render() {
		return (
			<TimeoutContext.Provider
				value={{
					...this.state,
					timeoutUpdate: this.handleTimeoutUpdate,
				}}
			>
				{this.props.children}
			</TimeoutContext.Provider>
		);
	}
}
